import {
  Banner,
  WhyArbitasSicav,
  FundOverview,
  FundTeam,
  KeyFundFacts,
  HistoryChart,
  ProjectsTitle,
  BothProjects,
} from '@widgets/main-page'
import { AnchorNavigation } from '@features/anchor-navigation'

export function MainPage() {
  return (
    <>
      <Banner />
      <AnchorNavigation sx={{ mb: { xs: 5.5, md: 18.75 } }} />
      <FundOverview sx={{ mb: { xs: 5.5, md: 18.75 } }} />
      <FundTeam sx={{ mb: { xs: 5.5, md: 18.75 } }} />
      <KeyFundFacts sx={{ mb: { xs: 5.5, md: 18.75 } }} />
      <HistoryChart sx={{ mb: { xs: 5.5, md: 18.75 } }} />
      <WhyArbitasSicav sx={{ mb: { xs: 5, md: 18.75 } }} />
      <ProjectsTitle sx={{ mb: { xs: 5.5, md: 18.75 } }} />
      <BothProjects sx={{ mb: { xs: 5.5, md: 18.75 } }} />
    </>
  )
}
